import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { VehicleTypes } from '../../models';
import { HttpClient } from '@angular/common/http';
import { CreateVehicleTypeRequest, PaginationVehicleTypeRequest } from '../vehicle-types';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';

@Injectable()
export class VehicleTypeService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
        ) {}
    public getVehicleTypes(request: PaginationVehicleTypeRequest, disableSpinner?: boolean): Observable<PaginationResponse<VehicleTypes>> {
        if(!disableSpinner) {
            this._spinner.show(true);
        }
        return this._http.get<PaginationResponse<VehicleTypes>>(`${API.VEHICLE_TYPE.GET_VEHICLE_TYPES}?${requestQuery(request)}`)
            .pipe(tap(() => this._spinner.hide()));
    }

    public create(model: CreateVehicleTypeRequest) {
        return this._http.post(`${API.VEHICLE_TYPE.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_VEHICLE_TYPE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateVehicleTypes(models: CreateVehicleTypeRequest[]) {
        return this._http.put(`${API.VEHICLE_TYPE.UPDATE_VEHICLE_TYPES}`, models)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_VEHICLE_TYPE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public update(model: CreateVehicleTypeRequest, id: string) {
        return this._http.put(API.VEHICLE_TYPE.UPDATE(id), model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_VEHICLE_TYPE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
    public delete(id:string) {
        return this._http.delete(API.VEHICLE_TYPE.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_VEHICLE_TYPE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
}
